import loadAll from './load-all'

export default {
  loadAll
}



// WEBPACK FOOTER //
// ./src/front/actions/config/index.js